import React from 'react';
import './style.scss';
import { Image, Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import Button from '../../../Shared/components/controls/Button';
import clsx from 'clsx';

const StepperLeft = ({ heading, text, link, image, darkMode, primaryButton, secondaryButton }) => {
  // Conditional rendering
  const needHeading = !!heading?.value;
  const needText = !!text?.value;
  const needImage = !!image?.value?.src;
  const needLink = !!link?.value?.href;
  const needPrimary = !!primaryButton?.value?.href;
  const needSecondary = !!secondaryButton?.value?.href;

  // In case all the BE data is empty
  if (!needHeading && !needText && !needLink && !needImage) return null;

  return (
    <div className={clsx('stepper-component-left', darkMode && 'stepper-component-left-dark')}>
      {needHeading && <Text tag="h3" className="stepper-comp-left-title" field={heading} />}
      {needText && <RichText className="stepper-comp-left-text" field={text} />}
      {(needPrimary || needSecondary || needLink) && (
        <div className="stepper-comp-left-buttons">
          {needPrimary && (
            <Button
              link={primaryButton}
              className="stepper-comp-left-link"
              variant="contained"
              color={darkMode ? 'secondary' : 'primary'}
            />
          )}
          {needSecondary && (
            <Button
              link={secondaryButton}
              className="stepper-comp-left-link"
              variant="outlined"
              color={darkMode ? 'secondary' : 'primary'}
            />
          )}
          {needLink && (
            <Button
              variant="text"
              link={link}
              className="stepper-comp-left-link"
              arrow="right"
              color={darkMode ? 'secondary' : 'primary'}
            />
          )}
        </div>
      )}
      {needImage && (
        <div className="stepper-comp-left-image-wrapper">
          <Image field={image} className="stepper-comp-left-image" />
        </div>
      )}
    </div>
  );
};

export default StepperLeft;
